export default __webpack_public_path__ + "static/media/bromindo.9774edc1.jpeg";